import {  FETCH_TASK, FETCH_TASKS, MODAL_ACTION, SET_TASK } from "../Dispatchers";

const initialState = {
    task: {},
    tasks:[],
    taskId:"",
    actionStatus:false,
}
export function TaskReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_TASKS:
            return {
                ...state, tasks: action.payload
            }
        case FETCH_TASK:
            return {
                ...state, task: action.payload
            }
        case SET_TASK:
            return {
                ...state, taskId: action.payload
            }
        case MODAL_ACTION:
            return {
                ...state, actionStatus: action.payload
            }

        default:
            break;
    }
    return state;
}